import FixedNav from "../components/Nav/FixedNav";
import MobileNav from "../components/Nav/MobileNav";
import Header from "../components/Description/Header";
import Title from "../components/Description/Title";
import Normal from "../components/Description/Normal";
import Big from "../components/Description/Big";

const Cookie = () => {
  return (
    <div id="body">
      <div className="framer-IqNBt framer-vrYYp framer-NrkXy framer-l50WH framer-V74Ls framer-uKIIJ framer-Fw2Wf framer-72rtr7 min-h-screen !w-auto">
        <FixedNav />
        <MobileNav />
        <div id="content" className="w-full mt-[60px] p-[20px]">
          <Header>Cookie policy and GDPR</Header>
          <div className="p-3" />
          <Normal>
            Here’s a Cookie Policy and a GDPR Compliance Statement for
            CodeBlaze: Cookie Policy
            <br />
            Last Updated: December 4, 2024
          </Normal>
          <div className="p-5" />
          <Title>1. Introduction</Title>
          <div className="p-3" />
          <Normal>
            At CodeBlaze, we value your privacy and are committed to providing a
            safe and transparent user experience. This Cookie Policy explains
            what cookies are, how we use them, and your options regarding cookie
            usage when you visit our website and use our services.
          </Normal>
          <div className="p-3" />
          <Normal>
            By using our website, you consent to our use of cookies as described
            in this policy.
          </Normal>
          <div className="p-5" />
          <Title>2. What Are Cookies?</Title>
          <div className="p-3" />
          <Normal>
            Cookies are small text files that are placed on your device
            (computer, tablet, or smartphone) when you visit a website. They are
            widely used to improve the functionality of websites, enhance the
            user experience, and provide personalized content and ads.
          </Normal>
          <div className="p-5" />
          <Title>3. How We Use Cookies</Title>
          <div className="p-3" />
          <Big>We use cookies for the following purposes:</Big>
          <div className="p-3" />
          <Normal>
            - Essential Cookies: Necessary for the basic functioning of our
            website and to enable certain features, such as account
            authentication and page navigation.
            <br />- Performance Cookies: Help us understand how users interact
            with our website, providing insights into website usage and
            performance. This helps us improve our platform.
            <br />- Functional Cookies: Allow us to remember your preferences
            and settings across sessions, improving your user experience on our
            website.
            <br />- Advertising and Targeting Cookies: Used to deliver relevant
            advertising to you based on your browsing habits. These cookies help
            us manage and analyze advertising campaigns.
          </Normal>
          <div className="p-5" />
          <Title>4. Types of Cookies We Use</Title>
          <div className="p-3" />
          <Normal>
            - Session Cookies: These cookies are temporary and are deleted once
            you close your browser.
            <br />- Persistent Cookies: These cookies remain on your device for
            a set period or until manually deleted. They help us remember your
            preferences and settings for future visits.
            <br />- First-Party Cookies: Set by our website and can only be read
            by our website.
            <br />- Third-Party Cookies: Set by external providers and may track
            your online activities across various websites.
          </Normal>
          <div className="p-5" />
          <Title>5. Managing Cookies</Title>
          <div className="p-3" />
          <Normal>
            You can manage or block cookies through your browser settings.
            However, please note that disabling certain cookies may impact your
            ability to use some parts of our website. For more information on
            how to manage cookies, visit the "Help" section of your browser or
            [www.allaboutcookies.org] or (http://www.allaboutcookies.org).
          </Normal>
          <div className="p-5" />
          <Title>6. Changes to This Cookie Policy</Title>
          <div className="p-3" />
          <Normal>
            We may update this Cookie Policy from time to time to reflect
            changes in our practices or legal requirements. When we make
            updates, we will post the new policy on our website with an updated
            “Last Updated” date.
          </Normal>
          <div className="p-8" />
          <Header>GDPR Compliance Statement</Header>
          <div className="p-3" />
          <Normal>Last Updated: December 4, 2024</Normal>
          <div className="p-5" />
          <Title>1. Introduction</Title>
          <div className="p-3" />
          <Normal>
            As part of our commitment to privacy and data protection, CodeBlaze
            adheres to the principles outlined in the General Data Protection
            Regulation (GDPR), which regulates the processing of personal data
            for individuals within the European Union (EU) and European Economic
            Area (EEA). This statement outlines how we comply with GDPR
            requirements and protect your personal data.
          </Normal>
          <div className="p-5" />
          <Title>2. Data Controller</Title>
          <div className="p-3" />
          <Big>
            CodeBlaze AI acts as the data controller for any personal data you
            provide to us. Our contact details for privacy inquiries are:
          </Big>
          <div className="p-3" />
          <Normal>
            - Email: support@codeblaze.ai
            <br />- Address: CodeBlaze AI, United State of America ( USA)
          </Normal>
          <div className="p-5" />
          <Title>3. Personal Data We Collect</Title>
          <div className="p-3" />
          <Big>We collect the following types of personal data:</Big>
          <div className="p-3" />
          <Normal>
            - Account Information: Email address, name, payment details for
            subscriptions, and account preferences.
            <br />- Service Usage Data: Information about your interactions with
            our Services, such as generated code, platform interactions, and
            usage statistics.
            <br />- Automatically Collected Data: IP address, browser type,
            device information, and usage logs.
          </Normal>
          <div className="p-5" />
          <Title>4. Legal Basis for Data Processing</Title>
          <div className="p-3" />
          <Big>
            We process your personal data based on the following legal grounds:
          </Big>
          <div className="p-3" />
          <Normal>
            - Consent: You provide consent when you use our website and
            Services, and when you sign up for an account or subscribe to our
            services.
            <br />- Contractual Necessity: Processing is necessary to provide
            you with the Services you have requested, including delivering,
            managing, and improving the platform.
            <br />- Legitimate Interests: We may process data to protect the
            security of our Services, improve our platform, and conduct business
            operations.
          </Normal>
          <div className="p-5" />
          <Title>5. Data Subject Rights</Title>
          <div className="p-3" />
          <Big>
            Under the GDPR, you have the following rights concerning your
            personal data:
          </Big>
          <div className="p-3" />
          <Normal>
            - Right to Access: You have the right to request a copy of the
            personal data we hold about you.
            <br />- Right to Rectification: You have the right to request that
            we correct any inaccurate or incomplete personal data.
            <br />- Right to Erasure: You may request the deletion of your
            personal data, subject to our retention policies.
            <br />- Right to Restrict Processing: You may request that we
            restrict the processing of your personal data under certain
            circumstances.
            <br />- Right to Data Portability: You have the right to receive
            your personal data in a structured, commonly used, and
            machine-readable format.
            <br />- Right to Object: You have the right to object to the
            processing of your personal data for direct marketing purposes.
          </Normal>
          <div className="p-3" />
          <Normal>
            To exercise any of these rights, please contact us at
            support@codeblaze.ai.
          </Normal>
          <div className="p-5" />
          <Title>6. Data Retention</Title>
          <div className="p-3" />
          <Normal>
            We retain personal data only for as long as necessary to fulfill the
            purposes for which it was collected, including for legal,
            accounting, or reporting requirements. After this period, we will
            securely delete or anonymize your data.
          </Normal>
          <div className="p-5" />
          <Title>7. Data Transfers</Title>
          <div className="p-3" />
          <Normal>
            If you are located in the European Economic Area (EEA), your
            personal data may be transferred outside the EEA, including to the
            United State of America ( USA) or United Arab Emirates (UAE). We
            ensure that such transfers are made in compliance with applicable
            data protection laws, using appropriate safeguards.
          </Normal>
          <div className="p-5" />
          <Title>8. Data Security</Title>
          <div className="p-3" />
          <Normal>
            We implement industry-standard security measures to protect your
            personal data from unauthorized access, disclosure, alteration, or
            destruction. This includes encryption, access controls, and regular
            security audits.
          </Normal>
          <div className="p-5" />
          <Title>9. Changes to This GDPR Compliance Statement</Title>
          <div className="p-3" />
          <Normal>
            We may update our GDPR Compliance Statement to reflect changes in
            our practices, legal requirements, or the Services we provide. When
            we update the statement, we will post the revised version on our
            website with the date of the update.
          </Normal>
          <div className="p-3" />
          <Normal>
            For more information on how we handle your data, please refer to our
            full Privacy Policy at [www.codeblaze.ai/privacy\] or
            (https://www.codeblaze.ai/privacy).
          </Normal>
          <div className="p-3" />
          <Normal>
            By using our Services, you acknowledge that you have read and
            understood our Cookie Policy and GDPR Compliance Statement.
          </Normal>
        </div>
      </div>
    </div>
  );
};

export default Cookie;
